// Single delegated listener for every ".quick-add-form" on the page (product
// cards), instead of one inline <script> per card. Product grids can render
// 15+ cards per section, and inline per-card scripts are parser-blocking —
// this file is loaded once, deferred, and handles all of them.
(function () {
  if (window.__avecamQuickAddDelegated) return;
  window.__avecamQuickAddDelegated = true;

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('quick-add-form')) return;

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector('[type="submit"]');
    if (button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    var formData = new FormData(form);
    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: formData,
    };

    try {
      await fetch('/cart/add.js', config);

      var sections = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (res) {
        return res.json();
      });

      if (sections['cart-drawer']) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

        var newDrawerInner = doc.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.replaceWith(newDrawerInner);
        }

        // Cart just received an item, so it can no longer be empty — without
        // this, the stale "is-empty" class kept the header/footer hidden via
        // CSS even though the drawer content above was already up to date.
        document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.remove('is-empty');
        document.querySelector('cart-drawer-items') && document.querySelector('cart-drawer-items').classList.remove('is-empty');

        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          // Troca o conteúdo inteiro do botão: com o carrinho vazio ainda não
          // existe .cart-count-bubble para substituir.
          var bubbleSection = bubbleDoc.querySelector('.shopify-section');
          var cartIcon = document.getElementById('cart-icon-bubble');
          if (bubbleSection && cartIcon) {
            cartIcon.innerHTML = bubbleSection.innerHTML;
          }
        }
      }

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.open) cartDrawer.open();
    } catch (error) {
      console.error('Erro:', error);
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  });
})();
